module.exports = __webpack_public_path__ + "static/media/logo-rodape.fe3c4152.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-rodape.svg
// module id = 1098
// module chunks = 58